
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work-with-us",
      function () {
        return require("private-next-pages/work-with-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work-with-us"])
      });
    }
  